import { buyerCouponProductsRepository } from '~/api/repository/buyer-coupon-products';

export const BUYER_COUPON_PRODUCTS_QUERY_KEY = {
  all: ['buyer-coupon-products'] as const,

  // 쿠폰 적용 가능 상품 목록 (무한 스크롤, 커서 페이지네이션)
  list: (buyerCouponId: number, sortType?: string) => ({
    queryKey: [
      '/api/market-place/v1/buyer-coupon/products',
      buyerCouponId,
      sortType,
    ] as const,
    queryFn: ({ pageParam }: { pageParam?: string[] } = {}) =>
      buyerCouponProductsRepository.getBuyerCouponProducts({
        buyerCouponId,
        sortType,
        searchAfter: pageParam,
      }),
    infinite: true,
  }),
};
